import React, { useState } from 'react';

/**
 * GroundingExercise — the 5-4-3-2-1 senses exercise, as a working stepper.
 * Moves through each sense at the user's pace; nothing is recorded. For the
 * "Anxious" mood, to help the body settle by coming back to the present.
 */
const STEPS = [
  { n: 5, verb: 'see', prompt: 'Look around and name five things you can see.' },
  { n: 4, verb: 'feel', prompt: 'Notice four things you can feel — your chair, your feet, the air.' },
  { n: 3, verb: 'hear', prompt: 'Listen for three things you can hear.' },
  { n: 2, verb: 'smell', prompt: 'Find two things you can smell.' },
  { n: 1, verb: 'taste', prompt: 'Notice one thing you can taste.' },
];

export const GroundingExercise: React.FC = () => {
  const [step, setStep] = useState(0);
  const [done, setDone] = useState(false);

  if (done) {
    return (
      <div className="mm-grounding mm-grounding--done">
        <span className="mm-grounding__big" aria-hidden="true">🌸</span>
        <p className="mm-grounding__prompt">Nicely done. Notice how your body feels now — a little steadier, perhaps.</p>
        <button type="button" className="mm-btn mm-btn--ghost" onClick={() => { setStep(0); setDone(false); }}>
          Start again
        </button>
      </div>
    );
  }

  const current = STEPS[step];
  return (
    <div className="mm-grounding">
      <div className="mm-grounding__counter" aria-hidden="true">{current.n}</div>
      <p className="mm-grounding__verb">things you can {current.verb}</p>
      <p className="mm-grounding__prompt">{current.prompt}</p>
      <div className="mm-grounding__dots" aria-hidden="true">
        {STEPS.map((_, i) => <span key={i} className={`mm-dot ${i <= step ? 'is-on' : ''}`} />)}
      </div>
      <div className="mm-activity__controls">
        {step > 0 && (
          <button type="button" className="mm-btn mm-btn--ghost" onClick={() => setStep((s) => s - 1)}>Back</button>
        )}
        <button
          type="button"
          className="mm-btn mm-btn--primary"
          onClick={() => (step < STEPS.length - 1 ? setStep((s) => s + 1) : setDone(true))}
        >
          {step < STEPS.length - 1 ? 'Next' : 'Finish'}
        </button>
      </div>
    </div>
  );
};

export default GroundingExercise;
